import React from 'react'
import PropTypes from 'prop-types'

export const Side = ({ className = '', children = null }) => (
  <aside className={className}>{children}</aside>
)

Side.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
}
